import React from "react";
import { graphql, PreloadedQuery, usePreloadedQuery } from "react-relay";
import { WidgetTaskCollection } from "widgets";
import { WidgetTaskCollectionMockPreviewQuery } from "./__generated__/WidgetTaskCollectionMockPreviewQuery.graphql";

export const WidgetTaskCollectionMockPreviewQUERY = graphql`
  query WidgetTaskCollectionMockPreviewQuery(
    $storecastId: ID!
    $input: PreviewWidgetTaskCollectionInput!
  ) @raw_response_type {
    dashboard(id: $storecastId) @required(action: THROW) {
      previewWidgetTaskCollection(input: $input) @required(action: THROW) {
        ...WidgetTaskCollection_widgetTaskCollection
      }
    }
  }
`;

type Props = {
  storecastId: string;
  queryRef: PreloadedQuery<WidgetTaskCollectionMockPreviewQuery>;
};

export function WidgetTaskCollectionMockPreview(props: Props) {
  const data = usePreloadedQuery(
    WidgetTaskCollectionMockPreviewQUERY,
    props.queryRef
  );
  return (
    <WidgetTaskCollection
      mode="IDLE"
      widget={data.dashboard.previewWidgetTaskCollection}
      storecastId={props.storecastId}
      interactive={false}
    />
  );
}
